"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useConfig_1 = __importDefault(require("./../../_util/useConfig"));
/**
 * 图标展示UI
 * @param props
 * @constructor
 */
var HoverSVG = function (props) {
    var enterUrl = props.enterUrl, leaveUrl = props.leaveUrl;
    // 获取样式的通用前缀
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    return (react_1.default.createElement("div", { className: "".concat(classPrefix, "__icons ").concat(classPrefix, "__icons--inline") },
        react_1.default.createElement("i", { className: "".concat(classPrefix, "__icons-img"), style: {
                backgroundImage: "url(".concat(leaveUrl, ")"),
            } }),
        react_1.default.createElement("i", { className: "".concat(classPrefix, "__icons--hover"), style: {
                backgroundImage: "url(".concat(enterUrl, ")"),
            } })));
};
exports.default = HoverSVG;
//# sourceMappingURL=HoverSVG.js.map